export default function isValidBirthdate(birthdate: Date | unknown): boolean {
  const today = new Date()
  today.setHours(0, 0, 0)

  if (!(birthdate instanceof Date) || today.getFullYear() - birthdate.getFullYear() > 120) {
    return false
  }

  return today.getFullYear() - birthdate.getFullYear() > 18
    ? true
    : birthdate.getMonth() < today.getMonth()
      ? true
      : birthdate.getDate() <= today.getDate()
}
